export default {
  data () {
    return {
      fetchingMore: false
    }
  },

  methods: {
    async fetchMore ({
      params,
      rootField,
      apolloQueryField,
      currPage
    }) {
      if (this.fetchingMore) {
        return
      }

      if (currPage + 1 > this[apolloQueryField].totalPages - 1) {
        return
      }
      currPage = currPage + 1

      this.fetchingMore = true
      // Fetch more data and transform the original result
      await this.$apollo.queries[apolloQueryField].fetchMore({
        // New variables
        variables: {
          params: {
            ...params,
            page: currPage
          }
        },
        // Transform the previous result with new data
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (rootField) {
            previousResult[rootField][apolloQueryField].currentPage = fetchMoreResult[rootField][apolloQueryField].currentPage
            previousResult[rootField][apolloQueryField].content = [...previousResult[rootField][apolloQueryField].content, ...fetchMoreResult[rootField][apolloQueryField].content]
          } else {
            previousResult[apolloQueryField].currentPage = fetchMoreResult[apolloQueryField].currentPage
            previousResult[apolloQueryField].content = [...previousResult[apolloQueryField].content, ...fetchMoreResult[apolloQueryField].content]
          }
          return previousResult
        }
      })
      this.fetchingMore = false
    }
  }
}
